import { PollenWidgetLazy } from './pollenWidgetLazy';

const props = [];

export const PollenWidgetDirective = reactDirective => reactDirective(PollenWidgetLazy, props);
PollenWidgetDirective.$inject = ['reactDirective'];

// eslint-disable-next-line no-undef
angular.module('WB.App').directive('pollenWidget', PollenWidgetDirective);